import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { App } from "./App";
import { ProveedorAuth } from "./auth/AuthContext";
import { ProveedorToast } from "./components/Toast";
import { ProveedorAuthSuperadmin } from "./superadmin/SuperadminAuthContext";
import "./styles/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <ProveedorToast>
        <ProveedorAuth>
          <ProveedorAuthSuperadmin>
            <App />
          </ProveedorAuthSuperadmin>
        </ProveedorAuth>
      </ProveedorToast>
    </BrowserRouter>
  </StrictMode>,
);
